


























import { defineComponent, computed, toRefs, ref } from '@vue/composition-api';
import { PropType } from 'vue';
import { AdgroupConfig, AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import placementBlockList from './index';
import { useAdgroupTanblockValidate, useStore } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-placement-block-list-compose';

export default defineComponent({
  name,
  components: {
    TtamPlacementBlockListSwitch: placementBlockList.TtamPlacementBlockListSwitch,
    TtamPlacementBlockListSwitchTips: placementBlockList.TtamPlacementBlockListSwitchTips,
    TtamPlacementBlockListBlockAppInfo: placementBlockList.TtamPlacementBlockListBlockAppInfo,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);
    const blockListNode = ref();
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value.aadvid);
    const { disabled } = placementBlockList.useSwitchPropsDisabled({
      adgroupConfig,
    });
    const { visible } = placementBlockList.usePropsVisible({
      adgroupData,
      campaignData,
    });
    const { tanBlockId, tanBlockList, tanBlockCount, isLoading, run } = placementBlockList.useDataSource();

    const { tanBlockValidator } = useAdgroupTanblockValidate({
      tanblockList: tanBlockList,
      tanblockId: tanBlockId,
    });

    const _excludeAppPackageId = computed({
      get: () => Boolean(props.adgroupData.excludeAppPackageId),
      set: v => {
        let emitV = '';

        if (v) {
          emitV = tanBlockId.value;
        }
        emit('change', emitV);
        blockListNode.value?.clearValidate?.();
      },
    });

    const onRefresh = () => {
      trackEvent('create_adgroup_block_list_refresh');
      run();
      // reload数据后，如果现在是表单值里的穿山甲ID不为空，那就更新为reload后的数据
      if (props.adgroupData?.excludeAppPackageId && props.adgroupData?.excludeAppPackageId !== tanBlockId.value) {
        emit('change', tanBlockId.value);
      }
    };

    return {
      _excludeAppPackageId,
      disabled,
      visible,
      onRefresh,
      tanBlockId,
      tanBlockList,
      tanBlockCount,
      isLoading,
      aadvid,
      tanBlockValidator,
      blockListNode,
    };
  },
});
